import React, { useState } from 'react';
import { Col, Row } from 'tea-component';
import MemeTrend from '../MemeTrend';
import MemeLangDistribution from '../MemeLangDistribution';
import MemeTrendFilter from '../MemeTrend/MemeTrendFilter';
import MemeDetailsWrapper from '../MemeDetailsWrapper';
import CardCommon from '@op/components/CardCommon';

interface IMemeDataSectionProps {
  loading: boolean;
  empty: boolean;
  filter: any;
  wholePageRef: React.RefObject<HTMLDivElement>;
  startOfTime: string;
  endOfTime?: string;
}

export default function MemeDataSection({
  filter,
  wholePageRef,
  loading,
  empty,
  startOfTime,
  endOfTime,
}: IMemeDataSectionProps) {
  const [currentFilter, setCurrentFilter] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<string | undefined>();
  const changeFilter = (val: any) => {
    setCurrentFilter({ ...(filter || {}), ...val });
  };

  return (
    <CardCommon
      loading={loading}
      loadingHeight={700}
      emptyHeight={700}
      empty={empty}
      contentCard
      className="dbom-meme-details-data-section"
    >
      <MemeTrendFilter
        filterValue={filter}
        instanceId="meme_trend"
        startOfTime={startOfTime}
        endOfTime={endOfTime}
        change={changeFilter}
      />
      <Row className="dbom-meme-details-row">
        <Col span={17}>
          <MemeTrend
            filter={currentFilter}
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
          />
        </Col>
        <Col span={7}>
          <MemeLangDistribution filter={currentFilter} />
        </Col>
      </Row>
      <MemeDetailsWrapper
        filter={currentFilter}
        wholePageRef={wholePageRef}
        selectedDate={selectedDate}
      />
    </CardCommon>
  );
}
